var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9313 2.0688C13.6313 1.76885 13.2244 1.60034 12.8001 1.60034C12.3758 1.60034 11.9689 1.76885 11.6689 2.0688L5.6001 8.1376V10.4H7.8625L13.9313 4.3312C14.2313 4.03116 14.3998 3.62426 14.3998 3.2C14.3998 2.77574 14.2313 2.36884 13.9313 2.0688Z",
    fill: "#09090B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6001 4.8C1.6001 4.37565 1.76867 3.96868 2.06873 3.66863C2.36878 3.36857 2.77575 3.2 3.2001 3.2H6.4001C6.61227 3.2 6.81575 3.28428 6.96578 3.43431C7.11581 3.58434 7.2001 3.78782 7.2001 4C7.2001 4.21217 7.11581 4.41565 6.96578 4.56568C6.81575 4.71571 6.61227 4.8 6.4001 4.8H3.2001V12.8H11.2001V9.6C11.2001 9.38782 11.2844 9.18434 11.4344 9.03431C11.5844 8.88428 11.7879 8.8 12.0001 8.8C12.2123 8.8 12.4158 8.88428 12.5658 9.03431C12.7158 9.18434 12.8001 9.38782 12.8001 9.6V12.8C12.8001 13.2243 12.6315 13.6313 12.3315 13.9314C12.0314 14.2314 11.6244 14.4 11.2001 14.4H3.2001C2.77575 14.4 2.36878 14.2314 2.06873 13.9314C1.76867 13.6313 1.6001 13.2243 1.6001 12.8V4.8Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilAlt);
export default __webpack_public_path__ + "static/media/PencilAlt.4ac01ab762daab2b7f0ffa0584aadf0f.svg";
export { ForwardRef as ReactComponent };